$ = jQuery.noConflict();

function scrollAnimations() {
  // Header style changes

  if ($(".c-hero").length > 0) {
    const block = $(".c-hero");
    const blockBottom = block.position().top + block["0"].offsetHeight;
    $(window).on("scroll", () => {
      const currentScrollPos = $(document).scrollTop();

      if (
        currentScrollPos >= block.position().top &&
        currentScrollPos < blockBottom
      ) {
        $(".c-header").addClass("c-header--transparent");
      } else {
        $(".c-header").removeClass("c-header--transparent");
      }
    });
  }

  if ($(".c-platform").length > 0) {
    const block = $(".c-platform");
    const blockBottom = block.position().top + block["0"].offsetHeight;
    $(window).on("scroll", () => {
      const currentScrollPos = $(document).scrollTop();
      if (
        currentScrollPos >= block.position().top &&
        currentScrollPos < blockBottom
      ) {
        $(".c-header").removeClass("c-header--transparent-alt");
        $(".c-header").removeClass("c-header--transparent");
        $(".c-header").addClass("c-header--light");
        $(".logo-white").hide();
        $(".logo-dark").show();
      } else {
        $(".c-header").removeClass("c-header--transparent-alt");
        $(".c-header").removeClass("c-header--light");
        $(".c-header").addClass("c-header--dark");
        $(".logo-white").show();
        $(".logo-dark").hide();
      }
    });
  }

  if ($(".c-testimonials").length > 0) {
    const block = $(".c-testimonials");
    const blockBottom = block.position().top + block["0"].offsetHeight;
    $(window).on("scroll", () => {
      const currentScrollPos = $(document).scrollTop();
      if (
        currentScrollPos >= block.position().top &&
        currentScrollPos < blockBottom
      ) {
        $(".c-header").removeClass("c-header--transparent");
        $(".c-header")
          .addClass("c-header--light")
          .addClass("c-header--transparent-alt");
        $(".logo-white").hide();
        $(".logo-dark").show();
      }
    });
  }

  $(".home [data-scrollto]").on("click", function (e) {
    e.preventDefault();
    const dest = $(this).data("scrollto");
    $("html, body").animate(
      {
        scrollTop: $("#" + dest).offset().top,
      },
      600
    );
  });

  $("[data-tab]").on("click", function (e) {
    e.preventDefault();
    const dest = $(this).data("tab");
    $(this).closest("section").find(".shown").removeClass("shown");
    $(this).parent().addClass("shown");
    $("#" + dest).addClass("shown");
  });
}

export default scrollAnimations;
